export default "__VITE_ASSET__B4zU3t3y__"